/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'
import type { SelectionsData } from '../types'

export interface PublishContextValue {
  selectionsData: SelectionsData
  setSelectionsData: React.Dispatch<React.SetStateAction<SelectionsData>>
}

export const PublishContext = React.createContext<PublishContextValue | null>(null)
